import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';
import isArray from 'lodash-es/isArray';

import { ApiCollectionsResponse } from '../lib/api/Collections';

import { useApi } from '../contexts/ApiContext';

type UseCollectionsOptions = Omit<
    Parameters<typeof useQuery<ApiCollectionsResponse>>[0],
    'queryKey' | 'queryFn'
> & {
    keepPreviousData?: boolean;
};

export default function useCollections(query = null, opts: UseCollectionsOptions = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const { data = null, ...queryResult } = useQuery({
        queryKey: ['collections', query],
        queryFn: ({ queryKey: [, queryParam], signal }) =>
            api.collections.get(queryParam, null, null, { signal }),
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    const { data: items = null, ...metadata } = isArray(data) ? { data } : data || {};

    return data !== null
        ? {
              items,
              ...metadata,
              ...queryResult,
          }
        : queryResult;
}
